import axios from 'axios';

export const searchLocalNumbersApi = (params) => axios.get('/billing/carrier/tn-inventory', { params });
export const searchTollFreeNumbersApi = (params) => axios.get('/billing/carrier/tf-inventory', { params });

export const validatePortNumbers = (phoneNumbers) => axios.post(`/buy/validate_portable_numbers?validate_numbers=${encodeURIComponent(JSON.stringify(phoneNumbers))}`);

export const get0ABJAddressInfo = (params) => axios.get('/jgdc/address/query', { params });
export const check0ABJInfo = (params) => axios.get('/jgdc/number/check', {params});
